import { toast } from "sonner";

import { useMutation, useQuery } from "@tanstack/react-query";

import { usePrivateAxios } from "./use-private-axios";

interface VerifyAddressData {
	address: string;
	cityId: string;
	stateId: string;
	userId: string;
}

export function useVerifyAddress() {
	const axios = usePrivateAxios();

	return useMutation({
		mutationKey: ["verify-address"],
		mutationFn: async (data: VerifyAddressData) => {
			return axios.post("/kyc/verify-address", data);
		},

		onError: () => toast.error("Failed to verify address"),
		onSuccess: () => {
			toast.success("Address verified successfully");
		}
	});
}

export function useVerifyIdentity(params: { id: string; status: string; verified: boolean }) {
	const axios = usePrivateAxios();
	return useQuery({
		queryKey: ["verify-identity", params],
		queryFn: async () => {
			return axios.get("/kyc/verify-identity", {
				params
			});
		}
	});
}
